import React from 'react';
import { Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import PrimaryButton from '@modules/common/components/buttons/PrimaryButton';
import config from '@config/config';

type Props = {
  activeClientsCount: number;
  limit?: number;
};

function ClientLimitReachedMessage({ limit, activeClientsCount }: Props) {
  if (limit !== undefined && activeClientsCount >= limit) {
    const nToDelete = activeClientsCount - limit + 1;
    return (
      <Message>
        <Message.Header>OAuth client limit reached</Message.Header>
        {limit === 0 ? (
          <p>Creating OAuth clients is not available for your account.</p>
        ) : (
          <p>
            Your account is limited to the maximum of <b>{limit}</b> active OAuth{' '}
            {limit > 1 ? <>clients</> : <>client</>}. You will have to delete{' '}
            {limit === 1 ? (
              <>it</>
            ) : nToDelete === 1 ? (
              <>an existing client</>
            ) : (
              <>
                at least <b>{nToDelete}</b> existing clients
              </>
            )}{' '}
            to create a new one.
          </p>
        )}
        <p>
          <PrimaryButton as={Link} to={config.BILLING_PATH}>
            Upgrade your account
          </PrimaryButton>{' '}
          {limit === 0 ? 'if you want to create OAuth' : 'if you need more'} clients.
        </p>
      </Message>
    );
  }
  return null;
}

export default ClientLimitReachedMessage;
